"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSessions = void 0;
var chat_1 = require("@yeobill/chat");
var effector_react_1 = require("effector-react");
function useSessions() {
    return Object.values(effector_react_1.useStore(chat_1.Calls.CallSessionList$));
}
exports.useSessions = useSessions;
//# sourceMappingURL=useSessions.js.map